import React from 'react';
import { useMutation } from '@apollo/client';
import AddFavoriteCookbookMealMutation from './AddFavoriteCookbookMealMutation';
import MealListQuery from '../MealList/CookbookMealListQuery';

interface IAddFavoriteCookbookMealConnectorApollo {
  children: ({
    addCookbookMealToFavorite,
  }: {
    addCookbookMealToFavorite: (mealId: number) => Promise<unknown>;
  }) => React.ReactElement;
}

const AddFavoriteCookbookMealConnectorApollo: React.FC<IAddFavoriteCookbookMealConnectorApollo> = ({
  children,
}) => {
  const searchCriteria = {
    favoriteMeals: true,
  };
  const [addToFavorite] = useMutation(AddFavoriteCookbookMealMutation, {
    refetchQueries: [
      {
        query: MealListQuery,
        variables: { searchCriteria },
      },
    ],
  });

  const createAddCookbookMealToFavorites = async (mealId: number) => {
    const response = await addToFavorite({
      optimisticResponse: {
        cookbook: {
          __typename: 'CookbookMutation',
          addFavoriteMeal: {
            __typename: 'BasicMutationSuccess',
            successCode: 200,
          },
        },
      },
      variables: { mealId },
      update: (cache) => {
        cache.modify({
          id: `CookbookMeal:${mealId}`,
          fields: {
            isFavorite() {
              return true;
            },
          },
        });
      },
    });

    return response;
  };

  return children({ addCookbookMealToFavorite: createAddCookbookMealToFavorites });
};

export default AddFavoriteCookbookMealConnectorApollo;
